import React from "react";
// react-router-dom
import { Link } from "react-router-dom";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
// styles
import styles from "./headerLinksStyle";

const useStyles = makeStyles(styles);
export default function HeaderLinks(props) {
  const classes = useStyles();
  return (
    <div className={classes.headerLinkContainer}>
      <div className={classes.itemContainer}>
        <Link to="/about" className={classes.link}>
          <div>About</div>
        </Link>
      </div>
      <div className={classes.itemContainer}>
        <Link to="/" className={classes.link}>
          <div>Blog</div>
        </Link>
      </div>
    </div>
  );
}
